import React from 'react';
import { Link } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActionButtons = props => {
    const { actions } = props;
    //Renderizo
    return (
        <React.Fragment>
            {
                actions.filter(a => a.granted).map((action, index) => (
                    action.link ? (
                        action.link.indexOf('http') !== -1 ? (
                            <a
                                key={`ab${index}`} 
                                className={`d-none d-sm-inline-block btn btn-sm btn-${ action.css } shadow-sm ml-1`} 
                                href={ action.link }
                                data-toggle="tooltip" 
                                title={ action.title }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i class="fas fa-download fa-sm text-white-50"></i>
                                &nbsp;
                                {
                                    action.text && action.text.trim() !== '' ? (
                                        action.text
                                    ) : null
                                }
                            </a>
                        ) : (
                            <Link
                                key={`ab${index}`} 
                                className={`d-none d-sm-inline-block btn btn-sm btn-${ action.css } shadow-sm ml-1`} 
                                to={ action.link }
                                data-toggle="tooltip" 
                                title={ action.title }
                                target={ action.newTab ? '_blank' : '_self' }
                            >
                                { 
                                    React.cloneElement(
                                        action.icon,
                                        {
                                            className: 'text-white-50'
                                        }
                                    )
                                }
                                &nbsp;
                                {
                                    action.text && action.text.trim() !== '' ? (
                                        action.text
                                    ) : null
                                }
                            </Link>
                        )
                    ) : action.handle ? (
                        <Button
                            key={`ab${index}`} 
                            className={`d-none d-sm-inline-block btn btn-sm btn-${ action.css } shadow-sm ml-1`} 
                            onClick={ action.handle }
                        >
                            { action.icon }
                        </Button>
                    ) : null
                ))
            }
        </React.Fragment>
    );
};

export default ActionButtons;